<template>
  <div v-if="viewTangibles">
    <label
      v-if="visibleHasRadioactiveCargoField"
      class="flex-label"
      style="color: #333; padding-bottom: 10px"
    >
      <input
        type="checkbox"
        id="checkbox"
        v-model="application.has_radioactive_cargo"
        :disabled="this.disabledInput"
      />
      &nbsp;
      {{ fieldTitle(TangiblesSectionFieldAliases.HAS_RADIOACTIVE_CARGO, PassSectionsEnum.tangibles) }}
    </label>
    <label
      v-if="visibleHasMaterialListField"
      class="flex-label"
      style="color: #333; padding-bottom: 10px"
    >
      <input
        type="checkbox"
        id="has-material-list-checkbox"
        v-model="application.has_material_list"
        :disabled="this.disabledInput"
      />
      &nbsp;
      {{ fieldTitle(TangiblesSectionFieldAliases.HAS_MATERIAL_LIST, PassSectionsEnum.tangibles) }}
    </label>
    <template v-if="visibleTangiblesFields">
      <div class="row">
      </div>
      <div class="row">
        <div class="col-md-4">
          <span>Наименование</span>
        </div>
        <div class="col-md-4">
          <span>Количество</span>
        </div>
        <div :class="{'col-md-2 col-xs-9': canRemoveTangibles, 'col-md-3': !canRemoveTangibles}">
          <span style="white-space: nowrap">Идентификатор / ед. измерения</span>
        </div>
        <div class="col-md-1 col-xs-3" v-if="canRemoveTangibles">
          <span></span>
        </div>
      </div>
      <div v-for="(tangible, tangiblesKey) in tangibles" :key="tangiblesKey" class="row">
        <div class="col-md-4 mt-10">
          <tangibles-input
            :form="form"
            :errors="errors"
            :disabled="disabledTangibles"
            :tangibles-id="tangiblesKey"
            v-model="tangible.name"
            @change="change('Tangibles name')"
          />
        </div>
        <div class="col-md-4 mt-10">
          <tangibles-count
              :form="form"
              :errors="errors"
              :disabled="disabledTangibles"
              :tangibles-id="tangiblesKey"
              v-model="tangible.count"
              @change="change('Tangibles count')"
          />
        </div>
        <div :class="{'col-md-3 col-xs-9': canRemoveTangibles, 'col-md-4': !canRemoveTangibles}" class="mt-10">
          <tangibles-identification
            :form="form"
            :errors="errors"
            :disabled="disabledTangibles"
            :tangibles-id="tangiblesKey"
            v-model="tangible.identification"
            @change="change('Tangibles identification')"
          />
        </div>
        <div class="col-md-1 col-xs-3" v-if="canRemoveTangibles">
          <div class="form-group mt-10">
            <button
              type="button"
              style="display: block"
              :id="`btn-${{tangiblesKey}}`"
              class="btn btn-sm btn-default form-control"
              @click="removeTangibles(tangiblesKey)"
              title="Удалить"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="tangibles-add" v-if="!isView">
        <div class="text-center">
          <div class="addNewVessel" id="form-vessels-button">
            <button type="button" class="btn btn-default" @click="addTangible">Добавить наименование</button>
          </div>
        </div>
      </div>
    </template>
    <br>
    <application-documents-block
      :application="application"
      :applicationDocuments="applicationDocuments"
      :form="form"
      :errors="errors"
    />
  </div>
</template>

<script>
import ApplicationDocumentsBlock from '@/common/components/application/ApplicationDocumentsBlock'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { Logger } from '@/common/helpers/Logger'
import mainMixin from '@/common/mixins/mainMixin'
import PassSectionsEnum from '@/common/enums/PassSectionsEnum'
import { TangiblesSectionFieldAliases } from '@/common/enums/ApplicationSectionFieldAliases'
import TangiblesCount from '@/common/components/application/form-inputs/pass/tangibles/TangiblesCount.vue'
import TangiblesIdentification from '@/common/components/application/form-inputs/pass/tangibles/TangiblesIdentification.vue'
import TangiblesInput from '@/common/components/application/form-inputs/pass/tangibles/TangiblesInput.vue'

export default {
  name: 'TangiblesFormBlock',

  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin
  ],

  components: {
    ApplicationDocumentsBlock,
    TangiblesInput,
    TangiblesIdentification,
    TangiblesCount
  },

  model: {
    prop: 'change-tangibles',
    event: 'change-tangibles'
  },

  props: {
    tangibles: {
      type: Array,
      default: () => [],
      required: true
    },

    application: {
      type: Object,
      required: true
    },

    applicationDocuments: {
      type: Array,
      default: () => []
    },

    applicationPurpose: {
      type: [Array, Object]
    },

    cfgFormFields: {
      type: [Array, Object],
      default: () => []
    }
  },

  created () {
    if (this.tangibles.length > 0) {
      this.form.tangibles = []
    }
  },

  computed: {
    PassSectionsEnum () {
      return PassSectionsEnum
    },

    TangiblesSectionFieldAliases () {
      return TangiblesSectionFieldAliases
    },

    visibleHasRadioactiveCargoField () {
      return this.fieldVisible(TangiblesSectionFieldAliases.HAS_RADIOACTIVE_CARGO, PassSectionsEnum.tangibles)
    },

    visibleHasMaterialListField () {
      return this.fieldVisible(TangiblesSectionFieldAliases.HAS_MATERIAL_LIST, PassSectionsEnum.tangibles)
    },

    // TODO: временно захардкожено - при приложенной описи поля материальных ценностей скрываются
    visibleTangiblesFields () {
      return !Number(this.application.has_material_list)
    },

    disabledTangibles () {
      return Boolean(this.disabledInput)
    },

    viewTangibles () {
      return this.isPassKindMaterial
    },

    canRemoveTangibles () {
      return Boolean(this.isPassKindMaterial && this.tangibles.length > 1 && !this.isView)
    }
  },

  watch: {
    visibleTangiblesFields (visible) {
      if (visible && !this.isView && this.tangibles.length === 0) {
        this.addTangible()
      }
    }
  },

  data: () => {
    return {
      baseUrl: process.env.BASE_URL
    }
  },

  methods: {
    change (inputName) {
      Logger.log(`Changed ${inputName}!`)
      this.$emit('change-tangibles', this.tangibles)
    },

    removeTangibles (tangiblesKey) {
      this.tangibles.splice(tangiblesKey, 1)
    },

    addTangible () {
      const tangible = Object.assign({}, {
        name: null,
        identification: null,
        count: null
      })
      this.tangibles.push(tangible)
    }
  }
}
</script>
